import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import strings from "translate/language";
import { followupList } from "reduxStore/action/followUpActions";
import { seo } from "utils/utils";
import {
  displayFollowupHistoryStatus,
  historyDescription,
  historyDescriptionLabel,
  resolveWalkinRemark,
} from "utils/followupHistoryDisplay";
import Breadcrumb from "component/common/breadcrumb";
import "./FollowupListing.css";
import "component/common/JustoDetailFooter.css";

const displayValue = (value) => {
  if (value == null || value === "" || value === "NA") {
    return strings.notavailable;
  }
  return value;
};

const isEmpty = (value) =>
  value == null || value === "" || value === "NA";

const AllFollowUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { lead_id = "" } = params || {};
  const [viewData, setViewData] = useState([]);
  const [walkinRemark, setWalkinRemark] = useState("");
  const allFollowupDetail = useSelector((state) => state.followUp) || {};

  useEffect(() => {
    const response = allFollowupDetail?.response;
    if (!response) return;
    if (response?.status === 200) {
      const rows = response.data;
      const list = Array.isArray(rows) ? rows : [];
      setViewData(list);
      setWalkinRemark(resolveWalkinRemark(response, list));
      return;
    }
    setViewData([]);
    setWalkinRemark("");
  }, [allFollowupDetail]);

  useEffect(() => {
    dispatch(followupList({ lead_id }));
  }, [dispatch, lead_id]);

  useEffect(() => {
    seo({
      title: "All Followup",
      metaDescription: "All followup",
      canonicalLink: window.location.href,
    });
  }, []);

  const first = viewData[0] || {};
  const propertyTitle =
    first.property_title || first.customer_first_name || strings.allFollowup;
  const appointmentId = first.appointment_id;

  return (
    <div className="page-body justo-followup-page">
      <Breadcrumb
        title={strings.allFollowup}
        url={"/followup"}
        parentListing={strings.followupList}
        titleactive={strings.allfollowup}
        isBackBtn={true}
      />

      <div className="container-fluid justo-followup">
        <div className="justo-followup__card justo-followup-detail">
          <div className="justo-followup-detail__hero">
            <div className="justo-followup-detail__hero-main">
              <h1 className="justo-followup-detail__property">
                {displayValue(propertyTitle)}
              </h1>
              <p className="justo-followup-detail__meta">
                <span>
                  History: <strong>{viewData.length}</strong>
                </span>
                {first.customer_first_name ? (
                  <span>
                    {strings.visitorName}:{" "}
                    <strong>{first.customer_first_name}</strong>
                  </span>
                ) : null}
              </p>
            </div>
          </div>

          <div className="justo-followup-detail__content">
            {viewData.length ? (
              <div className="justo-followup-history">
                {viewData.map((item, index) => {
                  const dateLabel = item.followup_date
                    ? moment(item.followup_date).format("DD-MM-YYYY, h:mm a")
                    : "";
                  const description = historyDescription(
                    item,
                    walkinRemark,
                    viewData,
                    "",
                  );
                  const descriptionLabel = historyDescriptionLabel(
                    item,
                    walkinRemark,
                    viewData,
                  );
                  const statusLabel = displayFollowupHistoryStatus(item, index);
                  return (
                    <section
                      className="justo-followup-detail__section"
                      key={item._id || index}
                    >
                      <h2 className="justo-followup-detail__section-title">
                        <span>
                          #{viewData.length - index}
                          {statusLabel ? ` · ${statusLabel}` : ""}
                        </span>
                        {dateLabel ? (
                          <span className="justo-followup-history__when">
                            {dateLabel}
                          </span>
                        ) : null}
                      </h2>
                      <dl className="justo-followup-detail__facts">
                        <div className="justo-followup-detail__fact">
                          <dt>{strings.followupBy}</dt>
                          <dd
                            className={
                              isEmpty(item.creator_name) ? "is-muted" : undefined
                            }
                          >
                            {displayValue(item.creator_name)}
                          </dd>
                        </div>
                        <div className="justo-followup-detail__fact">
                          <dt>{strings.status}</dt>
                          <dd
                            className={
                              isEmpty(statusLabel) ? "is-muted" : undefined
                            }
                          >
                            {displayValue(statusLabel)}
                          </dd>
                        </div>
                        <div className="justo-followup-detail__fact">
                          <dt>
                            {strings.date} & {strings.time}
                          </dt>
                          <dd
                            className={
                              isEmpty(dateLabel) ? "is-muted" : undefined
                            }
                          >
                            {displayValue(dateLabel)}
                          </dd>
                        </div>
                        <div className="justo-followup-detail__fact">
                          <dt>{descriptionLabel}</dt>
                          <dd
                            className={
                              isEmpty(description) ? "is-muted" : undefined
                            }
                          >
                            {displayValue(description)}
                          </dd>
                        </div>
                      </dl>
                    </section>
                  );
                })}
              </div>
            ) : (
              <p className="justo-followup-detail__empty">
                {strings.notavailable}
              </p>
            )}
          </div>

          <div className="justo-detail-footer">
            {appointmentId ? (
              <button
                type="button"
                className="justo-detail-footer__btn justo-detail-footer__btn--soft"
                onClick={() => navigate(`/revisit/${appointmentId}`)}
              >
                <i className="fa fa-phone" aria-hidden="true" />
                {strings.revisit}
              </button>
            ) : null}
            {lead_id ? (
              <button
                type="button"
                className="justo-detail-footer__btn justo-detail-footer__btn--solid"
                onClick={() => navigate(`/updatestatusfollow/${lead_id}`)}
              >
                {strings.statusUpdate}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllFollowUp;
